import { render, staticRenderFns } from "./PrintLabel.vue?vue&type=template&id=4fe50a18&scoped=true"
import script from "./PrintLabel.vue?vue&type=script&lang=ts"
export * from "./PrintLabel.vue?vue&type=script&lang=ts"
import style0 from "./PrintLabel.vue?vue&type=style&index=0&id=4fe50a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe50a18",
  null
  
)

export default component.exports